import { FormControl, MenuItem, Select } from "@mui/material";
import { useCallback, useContext, useEffect, useState } from "react";
import { CgClose } from "react-icons/cg";
import {
  HiOutlineArrowRightOnRectangle,
  HiOutlineBanknotes,
  HiOutlineBuildingOffice2,
  HiOutlineCalendarDays,
  HiOutlineChatBubbleLeftRight,
  HiOutlineClipboardDocumentList,
  HiOutlineClock,
  HiOutlineCog6Tooth,
  HiOutlineCreditCard,
  HiOutlineDocumentText,
  HiOutlineEnvelope,
  HiOutlineFaceSmile,
  HiOutlineHome,
  HiOutlineKey,
  HiOutlineMegaphone,
  HiOutlineTicket,
  HiOutlineUserGroup,
  HiOutlineUserPlus,
  HiOutlineUsers,
} from "react-icons/hi2";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../pages/auth/AuthContext";
import { useDispatch, useSelector } from "react-redux";
import defaultDP from '../../src/assets/images/avatar-design.png';
import clubLogoImg from "../assets/images/SportMingleLogoMark.png";
import { rootAction } from "../redux/reducer/rootReducer";
import SideBarLink from "./SideBarLink";
import { formatRoleLabel, isClubOwner, isClubStaff, isCoach, isGuest, isUser } from "../util/UserRoles";
import { canAccessAdsSponsorship } from "../util/adsPrivileges";
import { canViewAdminSettings } from "../util/featurePrivileges";
import { IoIosAddCircleOutline, IoIosArrowDown } from "react-icons/io";
import { setSelectedClub } from "../redux/reducer/userReducer";
import { PrivilegeAPI } from "../api/PrivilegesAPI";
import { getPlayerLabelByGame } from "../util/SideBarUtil";
import CustomAccordian from "../pages/CustomComponents/CustomAccordian/CustomAccordian";
import RoleTooltip from "./RoleTooltip";

const SideBar = () => {
  const { signOut } = useContext(AuthContext);
  const dispatch = useDispatch();
  const userInfo = useSelector((store) => store.user.userInfo);
  const selectedClub = useSelector((store) => store.user.selectedClub);
  const { openSlideBar, sideBarLink, activeTab } = useSelector((store) => store.root);
  const [link, setLink] = useState('');
  const navigate = useNavigate();
  const [refresh, setRefresh] = useState(false);
  const [privilegeList, setPrivilegeList] = useState([])


  const findLinkPrivileges = async () => {
    try {
      const response = await PrivilegeAPI.getAllPrivilegesForSideBar(userInfo.userId);
      setPrivilegeList(response.Data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (userInfo.userId) {
      findLinkPrivileges();
    }
  }, [userInfo.userId])

  useEffect(() => {
    activeLink();
    setRefresh(false);
  }, [refresh, sideBarLink]);

  const handleLogout = async (e) => {
    try {
      await signOut(userInfo?.userName);
      setLink('');
      navigate("/login", { replace: true });
    } catch (err) {
    }
  };
  if (sideBarLink == '') {
    document.title = 'Dashboard';
  } else {
    if (sideBarLink === "coach-scheduler") {
      document.title = "Coach Schedule";
    } else if (sideBarLink === "calender") {
      document.title = "Schedule";
    } else if (sideBarLink === "reservation-history" || sideBarLink === "event-history") {
      document.title = "History";
    } else if (sideBarLink) {
      document.title = sideBarLink?.replace('-', ' ')?.charAt(0).toUpperCase() + sideBarLink?.replace('-', ' ')?.slice(1).toLowerCase();
    } else {
      document.title = "Sportmingle"
    }
  }
  const activeLink = () => {
    dispatch(rootAction.setSlideBarLink(window.location.pathname.split('/').pop()));
    if (sideBarLink === "") {
      dispatch(rootAction.setActiveTab({ dashboard: true }));
    } else if (sideBarLink === "calender-setup") {
      dispatch(rootAction.setActiveTab({ calenderSetup: true }));
    } else if (sideBarLink === "calendar") {
      dispatch(rootAction.setActiveTab({ calendar: true }));
    } else if (sideBarLink === "payment-details") {
      dispatch(rootAction.setActiveTab({ payment: true }));
    } else if (sideBarLink === "players") {
      dispatch(rootAction.setActiveTab({ players: true }));
    } else if (sideBarLink === "finances") {
      dispatch(rootAction.setActiveTab({ finances: true }));
    } else if (sideBarLink === "email-notify") {
      dispatch(rootAction.setActiveTab({ notify: true }));
    } else if (sideBarLink === "plan-setup") {
      dispatch(rootAction.setActiveTab({ planSetup: true }));
    } else if (sideBarLink === "profile") {
      dispatch(rootAction.setActiveTab({ profile: true }));
    } else if (sideBarLink === "account-setup") {
      dispatch(rootAction.setActiveTab({ accountSetup: true }));
    } else if (sideBarLink === "club-setup") {
      dispatch(rootAction.setActiveTab({ clubSetup: true }));
    } else if (sideBarLink === "reservation-history") {
      dispatch(rootAction.setActiveTab({ reservationHistory: true }));
    } else if (sideBarLink === "access-management") {
      dispatch(rootAction.setActiveTab({ accessManagement: true }));
    } else if (sideBarLink === "invite-member") {
      dispatch(rootAction.setActiveTab({ inviteStaff: true }));
    } else if (sideBarLink === "coach-plan") {
      dispatch(rootAction.setActiveTab({ coachPlan: true }));
    } else if (sideBarLink === "roster") {
      dispatch(rootAction.setActiveTab({ roster: true }));
    } else if (sideBarLink === "add-org") {
      dispatch(rootAction.setActiveTab({ addOrg: true }));
    } else if (sideBarLink === "join-requests") {
      dispatch(rootAction.setActiveTab({ joinRequest: true }));
    } else if (sideBarLink === "events") {
      dispatch(rootAction.setActiveTab({ event: true }));
    } else if (sideBarLink === "my-kids") {
      dispatch(rootAction.setActiveTab({ myKids: true }));
    } else if (sideBarLink === "coach-scheduler") {
      dispatch(rootAction.setActiveTab({ scheduler: true }));
    } else if (sideBarLink === "teams") {
      dispatch(rootAction.setActiveTab({ team: true }));
    } else if (sideBarLink === "registration-setup") {
      dispatch(rootAction.setActiveTab({ registrationSetup: true }));
    } else if (sideBarLink === "event-history") {
      dispatch(rootAction.setActiveTab({ eventHistory: true }));
    } else if (sideBarLink === "chat") {
      dispatch(rootAction.setActiveTab({ chat: true }));
    } else if (sideBarLink === "ads-sponsorship") {
      dispatch(rootAction.setActiveTab({ adsSponsorship: true }));
    }

    setRefresh(true);
  };
  const closeWithClick = () => {
    activeLink();
    if (window.innerWidth <= 1000) {
      dispatch(rootAction.setOpenSlideBar(false))
    }
  };
  const handleSelectClub = (val) => {
    if (val !== 'add') {
      const newClub = userInfo.clubs.filter((club) => club.clubId === val);
      dispatch(setSelectedClub(newClub[0]));
    }
  }
  const closeWithClickAndRedirect = () => {
    if (window.innerWidth <= 1000 && (!isUser(userInfo))) {
      dispatch(rootAction.setOpenSlideBar(false));
      dispatch(rootAction.setActiveTab({ clubProfile: true }));
      navigate('/club-setup')
    }
  };

  const getRoleNames = useCallback(() => {
    if (!userInfo?.authorities) return '';

    return userInfo.authorities
      .map(role => formatRoleLabel(role.roleName))
      .filter(Boolean)
      .join(', ');
  }, [userInfo]);

  const accountSetupIncomplete = selectedClub?.accountSetupIsCompleted === false;
  const canSeeAdminTools = isClubOwner(userInfo) || canViewAdminSettings(privilegeList);
  const showFinances = ["MANAGE_TRANSACTION", "MANAGE_PAYOUT", "MANAGE_ACCOUNT"].some((key) => privilegeList?.includes(key));
  const showRegistration = privilegeList?.includes("MANAGE_FORM_TEMPLATE");
  const showPlan = privilegeList?.includes("MANAGE_PLATFORM_PLAN")
    || privilegeList?.includes("MANAGE_CLUB_PLAN")
    || privilegeList?.includes("MANAGE_ONE_TIME_ACTIVATION_FEE");
  const showCalendarSettings = (privilegeList?.includes("MANAGE_COURT") && selectedClub?.calendarType === "RESERVATION_CALENDAR")
    || privilegeList?.includes("MANAGE_CLUB_TIME")
    || privilegeList?.includes("MANAGE_TIMEZONE_INTERVAL");
  const showClub = privilegeList?.includes("MANAGE_CLUB_PROFILE");
  const showAccess = isClubOwner(userInfo);
  const showAccountSetupLink = accountSetupIncomplete && !isClubStaff(userInfo) && canSeeAdminTools;
  const showSetupChildren = !accountSetupIncomplete && (showFinances || showRegistration || showPlan || showCalendarSettings || showClub || showAccess);
  const showSetup = showAccountSetupLink || showSetupChildren;
  const showAdminPrograms = !accountSetupIncomplete && canSeeAdminTools && (
    privilegeList?.includes("MANAGE_EVENT")
    || privilegeList?.includes("MANAGE_ROSTER")
    || privilegeList?.includes("MANAGE_TEAM")
  );
  const playerLabel = getPlayerLabelByGame(selectedClub?.games && selectedClub?.games[0]?.gameName);
  const clubCalendarType = String(selectedClub?.calendarType || "").trim().toUpperCase();
  const isEventCalendar = clubCalendarType === "EVENT_CALENDAR";
  const isReservationCalendar = clubCalendarType === "RESERVATION_CALENDAR";



  return (
    <div
      className={
        openSlideBar
          ? "root-dashboard-sidebar active"
          : "root-dashboard-sidebar"
      }
    >
      <div className="slidebar-close">
        <CgClose
          onClick={() => dispatch(rootAction.setOpenSlideBar(!openSlideBar))}
          className="slidebar-close-icon"
        />
      </div>
      <div className="header_club_info_sidebar">
        <FormControl
          className="seleted_club_dropdown sm-sidebar-club"
        >
          <Select
            disabled={isCoach(userInfo)}
            IconComponent={(isCoach(userInfo) || isClubOwner(userInfo)) ? () => <></> : IoIosArrowDown}
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={selectedClub?.clubId || ''}
            size="small"

            MenuProps={{
              disableScrollLock: true,
            }}
            onChange={(val) => handleSelectClub(val.target.value)}
          >
            {
              userInfo?.clubs?.map((club, index) =>
                <MenuItem sx={{
                  '&.Mui-selected': {
                    backgroundColor: 'var(--hoverColorLightest)',
                  },
                  '&.Mui-selected:hover': {
                    backgroundColor: 'var(--hoverColorLight)',
                  },
                }} key={index} value={club?.clubId}>
                  <div className='header_club_info_item_sidebar'>
                    <img src={club?.clubLogo ? `${import.meta.env.VITE_APP_BASE_URL}/club/club-logo-img/${club?.clubLogo}` : clubLogoImg} alt="" />
                    <h2 data-testid="club_name" >{club?.clubName}</h2>
                  </div>
                </MenuItem>
              )
            }
            <MenuItem value="add">
              <div className='header_club_info_add_club' onClick={() => navigate("/add-org")}>
                <IoIosAddCircleOutline className="header_club_info_add_club_icon" />
                <p>Add Organization</p>
              </div>
            </MenuItem>
          </Select>
        </FormControl>
      </div>
      <div className="root-dashboard-sidebar-profile">
        <RoleTooltip title={getRoleNames()} placement={openSlideBar ? "bottom" : "right"}>
          <Link
            onClick={closeWithClick}
            style={{ backgroundImage: `url(${userInfo?.profileImage ? import.meta.env.VITE_APP_BASE_URL + '/user/user-profile-img/' + userInfo?.profileImage : defaultDP})` }}
            to={'/profile'}
            className="root-dashboard-sidebar-profile-img"
          >
            <span style={{ "--i": "1" }}></span>
            <span style={{ "--i": "2" }}></span>
            <span style={{ "--i": "3" }}></span>
          </Link>
        </RoleTooltip>
        <Link
          onClick={closeWithClick}
          className="root-dashboard-sidebar-profile-name"
        >
          <p>{userInfo?.firstName + " " + userInfo?.lastName}</p>
        </Link>
      </div>
      <div className="root-dashboard-sidebar-section">

        <div className="root-dashboard-sidebar-my-plan">
          <CustomAccordian title="My Account">
            <SideBarLink
              to="/"
              closeWithClick={closeWithClick}
              name="Dashboard"
              activeTab={activeTab.dashboard}
              LinkIcon={HiOutlineHome}
            />
            {(!selectedClub?.freePlanUser || (
              !isClubOwner(userInfo) && (isCoach(userInfo) || isUser(userInfo))
            )) &&
              <SideBarLink
                to="/payment-details"
                closeWithClick={closeWithClick}
                name={isClubOwner(userInfo) ? "Payment" : "Payment & Plan"}
                activeTab={activeTab.payment}
                LinkIcon={HiOutlineCreditCard}
              />
            }
          </CustomAccordian>
        </div>

        <div className="root-dashboard-sidebar-my-plan">
          <CustomAccordian title="Calendar">
            {isEventCalendar ? (
              <>
                <SideBarLink
                  to="/coach-scheduler"
                  closeWithClick={closeWithClick}
                  name="Coach Schedule"
                  activeTab={activeTab.scheduler}
                  LinkIcon={HiOutlineCalendarDays}
                />
                <SideBarLink
                  to="/event-history"
                  closeWithClick={closeWithClick}
                  name="History"
                  activeTab={activeTab.eventHistory}
                  LinkIcon={HiOutlineClock}
                />
              </>
            ) : isReservationCalendar ? (
              <>
                <SideBarLink
                  to="/calendar"
                  closeWithClick={closeWithClick}
                  name="Schedule"
                  activeTab={activeTab.calendar}
                  LinkIcon={HiOutlineCalendarDays}
                />
                <SideBarLink
                  to="/reservation-history"
                  closeWithClick={closeWithClick}
                  name="History"
                  activeTab={activeTab.reservationHistory}
                  LinkIcon={HiOutlineClock}
                />
              </>
            ) : null}
          </CustomAccordian>
        </div>

        {!isClubOwner(userInfo) &&
          <div className="root-dashboard-sidebar-my-plan">
            <CustomAccordian title="Family">
              <SideBarLink
                to="/my-kids"
                closeWithClick={closeWithClick}
                name="My Kids"
                activeTab={activeTab.myKids}
                LinkIcon={HiOutlineFaceSmile}
              />
            </CustomAccordian>
          </div>
        }

        {(isUser(userInfo) || isGuest(userInfo)) &&
          <div className="root-dashboard-sidebar-my-plan">
            <CustomAccordian title="Programs">
              <SideBarLink
                to="/events"
                closeWithClick={closeWithClick}
                name="Events"
                activeTab={activeTab.event}
                LinkIcon={HiOutlineTicket}
              />
              <SideBarLink
                to="/roster"
                closeWithClick={closeWithClick}
                name="Roster"
                activeTab={activeTab.roster}
                LinkIcon={HiOutlineUserGroup}
              />
              {privilegeList?.includes("MANAGE_TEAM") &&
                <SideBarLink
                  to="/teams"
                  closeWithClick={closeWithClick}
                  name="Teams"
                  activeTab={activeTab.team}
                  LinkIcon={HiOutlineUsers}
                />}
            </CustomAccordian>
          </div>}

        {selectedClub?.accountSetupIsCompleted !== false && ((isClubOwner(userInfo) || isClubStaff(userInfo)) && selectedClub?.clubOwner) &&
          <div className="root-dashboard-sidebar-my-plan">
            <CustomAccordian title="Members">
              <SideBarLink
                to="/players"
                closeWithClick={closeWithClick}
                name={`Manage ${playerLabel}`}
                activeTab={activeTab.players}
                LinkIcon={HiOutlineUsers}
              />
              {(selectedClub?.accountSetupIsCompleted && privilegeList?.includes("MANAGE_INVITE_STAFF")) &&
                <SideBarLink
                  to="/invite-member"
                  closeWithClick={closeWithClick}
                  name="Invite member"
                  activeTab={activeTab.inviteStaff}
                  LinkIcon={HiOutlineUserPlus}
                />
              }
            </CustomAccordian>
          </div>}

        {showAdminPrograms &&
          <div className="root-dashboard-sidebar-my-plan">
            <CustomAccordian title="Programs">
              {privilegeList?.includes("MANAGE_EVENT") &&
                <SideBarLink
                  to="/events"
                  closeWithClick={closeWithClick}
                  name="Events"
                  activeTab={activeTab.event}
                  LinkIcon={HiOutlineTicket}
                />}
              {privilegeList?.includes("MANAGE_ROSTER") &&
                <SideBarLink
                  to="/roster"
                  closeWithClick={closeWithClick}
                  name="Roster"
                  activeTab={activeTab.roster}
                  LinkIcon={HiOutlineUserGroup}
                />}
              {privilegeList?.includes("MANAGE_TEAM") &&
                <SideBarLink
                  to="/teams"
                  closeWithClick={closeWithClick}
                  name="Teams"
                  activeTab={activeTab.team}
                  LinkIcon={HiOutlineUsers}
                />}
            </CustomAccordian>
          </div>}

        {selectedClub?.accountSetupIsCompleted !== false && canAccessAdsSponsorship(privilegeList) && (
          <div className="root-dashboard-sidebar-my-plan">
            <CustomAccordian title="Advertising">
              <SideBarLink
                to="/ads-sponsorship"
                closeWithClick={closeWithClick}
                name="Ads & Sponsors"
                activeTab={activeTab.adsSponsorship}
                LinkIcon={HiOutlineMegaphone}
              />
            </CustomAccordian>
          </div>
        )}
        {selectedClub?.accountSetupIsCompleted !== false && !isGuest(userInfo) &&
          <div className="root-dashboard-sidebar-my-plan">
            <CustomAccordian title="Communication">
              {privilegeList?.includes("MANAGE_EMAIL_NOTIFICATION") &&
                <SideBarLink
                  to="/email-notify"
                  closeWithClick={closeWithClick}
                  name="Email"
                  activeTab={activeTab.notify}
                  LinkIcon={HiOutlineEnvelope}
                />}
              <SideBarLink
                to="/chat"
                closeWithClick={closeWithClick}
                name="Chat"
                activeTab={activeTab.chat}
                LinkIcon={HiOutlineChatBubbleLeftRight}
              />
            </CustomAccordian>
          </div>
        }

        {showSetup &&
          <div className="root-dashboard-sidebar-my-plan">
            <CustomAccordian title="Setup">
              {showAccountSetupLink &&
                <SideBarLink
                  to="/account-setup"
                  closeWithClick={closeWithClick}
                  name="Account Setup"
                  activeTab={activeTab}
                  LinkIcon={HiOutlineCog6Tooth}
                />}
              {showSetupChildren &&
                <>
                  {showFinances &&
                    <SideBarLink
                      to="/finances"
                      closeWithClick={closeWithClick}
                      name="Finances"
                      activeTab={activeTab.finances}
                      LinkIcon={HiOutlineBanknotes}
                    />}
                  {showRegistration &&
                    <SideBarLink
                      to="/registration-setup"
                      closeWithClick={closeWithClick}
                      name="Registration"
                      activeTab={activeTab.registrationSetup}
                      LinkIcon={HiOutlineDocumentText}
                    />}
                  {showPlan &&
                    <SideBarLink
                      to="/plan-setup"
                      closeWithClick={closeWithClick}
                      name="Plan"
                      activeTab={activeTab.planSetup}
                      LinkIcon={HiOutlineClipboardDocumentList}
                    />}
                  {showCalendarSettings &&
                    <SideBarLink
                      to="/calender-setup"
                      closeWithClick={closeWithClick}
                      name="Calendar settings"
                      activeTab={activeTab.calenderSetup}
                      LinkIcon={HiOutlineCalendarDays}
                    />}
                  {showClub &&
                    <SideBarLink
                      to="/club-setup"
                      closeWithClick={closeWithClick}
                      name="Club"
                      activeTab={activeTab.clubSetup}
                      LinkIcon={HiOutlineBuildingOffice2}
                    />}
                  {showAccess &&
                    <SideBarLink
                      to="/access-management"
                      closeWithClick={closeWithClick}
                      name="Access"
                      activeTab={activeTab.accessManagement}
                      LinkIcon={HiOutlineKey}
                    />}
                </>}
            </CustomAccordian>
          </div>}
      </div>
      <div className="root-dashboard-sidebar-logout">
        <h4 onClick={handleLogout} title="Log out">
          <HiOutlineArrowRightOnRectangle className="root-dashboard-sidebar-logout-icon" />
          <span className="slide-bar-label">Log out</span>
        </h4>
      </div>
    </div>
  );
};

export default SideBar;